import { HTMLAttributes, ReactElement, ReactNode } from 'react';
import cn from 'classnames';

import classes from './ContainerCard.module.css';
import { Heading } from '../Heading';
import { useTabletAndDownQuery } from '../../hooks/useTabletAndDownQuery.ts';

export type ContainerCardProps = {
  children: ReactNode;
} & HTMLAttributes<HTMLDivElement>;

export type ContainerCardTitleProps = {
  children: string;
  icon?: ReactNode;
  link?: ReactNode;
};

export const ContainerCard = ({
  children,
  className: givenClassName,
}: ContainerCardProps): ReactElement => {
  const combinedClassName = cn(classes.container, givenClassName);
  return <div className={combinedClassName}>{children}</div>;
};

ContainerCard.Title = function Title({
  children,
  icon,
  link,
}: ContainerCardTitleProps) {
  return (
    <div className={classes.titleWrapper}>
      <div className={classes.headerContent}>
        {icon && <div className={classes.icon}>{icon}</div>}
        <Heading as="h3" className={classes.title}>
          {children}
        </Heading>
      </div>
      {link && <div className={classes.button}>{link}</div>}
    </div>
  );
};

ContainerCard.SubHeader = function SubHeader({
  children,
}: {
  children: ContainerCardProps['children'];
}) {
  const isTabletAndDown = useTabletAndDownQuery();
  return (
    <div
      className={cn(classes.subHeader, {
        [classes.subHeaderSmallScreen]: isTabletAndDown,
      })}
    >
      {children}
    </div>
  );
};

ContainerCard.Body = function Body({
  children,
  noPadding = false,
  className,
}: {
  children: ContainerCardProps['children'];
  className?: string;
  noPadding?: boolean;
}) {
  const containerCardBodyClassname = cn(className, {
    [classes.noPaddingBody]: noPadding,
    [classes.body]: !noPadding,
  });
  return <div className={containerCardBodyClassname}>{children}</div>;
};

ContainerCard.Footer = function Footer({
  children,
}: {
  children: ContainerCardProps['children'];
}) {
  return <div className={classes.footer}>{children}</div>;
};
